<template>
  <transition
    enter-active-class="transition-transform duration-300 ease-out"
    leave-active-class="transition-transform duration-300 ease-in"
    enter-from-class="-translate-y-full"
    leave-to-class="-translate-y-full"
  >
    <div
      v-if="showPopup"
      class="fixed inset-x-0 top-0 z-[1000] flex items-center justify-center bg-[var(--mcb-color-teal-original)] p-3 text-center text-white shadow-[0_2px_10px_rgba(0,0,0,0.1)]"
      role="status"
    >
      <div class="mx-auto flex w-full max-w-[760px] items-center justify-between gap-3 font-sans">
        <div class="flex flex-1 items-center justify-center text-[15px] max-md:text-[13px]">
          <div v-if="isIos">
            <span
              class="mr-2 inline-block rounded-md bg-white px-2 py-1 text-[var(--color-primary-dark-grey)]"
            >
              {{ $t('install_app.install') }}
            </span>
            {{ $t('install_app.open_safari') }}
            <strong>{{ $t('install_app.share') }}</strong>
            (<i
              class="pi pi-share-alt mx-1 align-middle"
              aria-hidden="true"
            />),
            {{ $t('install_app.then') }}
            <strong>"{{ $t('install_app.add_to_home') }}"</strong>.
          </div>

          <div
            v-else
            class="flex flex-col items-center gap-2 sm:flex-row"
          >
            <Button
              size="small"
              severity="secondary"
              icon="pi pi-download"
              icon-pos="right"
              :label="$t('install_app.install')"
              data-testid="install-button"
              class=""
              @click="installApp"
            />
            <span>{{ $t('install_app.better_exp') }}</span>
          </div>
        </div>

        <Button
          v-tooltip.bottom="$t('common.close')"
          icon="pi pi-times"
          text
          rounded
          aria-label="Close notification"
          class="!text-white hover:!bg-white/10"
          @click="closePopup"
        />
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Button from 'primevue/button';
import Tooltip from 'primevue/tooltip';
import useInstallPrompt from '@/composables/useInstallPrompt';

export default defineComponent({
  name: 'InstallPromptComponent',
  components: { Button },
  directives: {
    tooltip: Tooltip,
  },
  setup() {
    const { showPopup, isIos, installApp, closePopup } = useInstallPrompt();
    return { showPopup, isIos, installApp, closePopup };
  },
});
</script>
